export * from './_imgs-slider/imgs-slider.component';
export * from './_loja/loja.component';
export * from './_produto-promocoes/produto-promocoes.component';
